import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { StaticLeaseLinkWidget } from 'site-modules/shared/components/static-lease-link-widget/static-lease-link-widget';

export const PopularLeaseProgramsEntry = memo(props => {
  const { entry } = props;

  return <StaticLeaseLinkWidget creativeId={entry.metadata('creative-id').value()} className="mt-1_5" />;
});

PopularLeaseProgramsEntry.displayName = 'PopularLeaseProgramsEntry';
PopularLeaseProgramsEntry.propTypes = {
  entry: PropTypes.shape({
    metadata: PropTypes.func.isRequired,
  }).isRequired,
};
